import { useCallback } from 'react';
import { FileSource } from '@server/application/files/types/file.types';
import { RcFile } from 'antd/es/upload';
import { useNotificationContext } from '@/features/notifications';
import { OpenapiContentType, useUploadOrganizationFile } from '@/shared/api';

export const useLocalFileUpload = () => {
  const { showNotification } = useNotificationContext();
  const { mutateAsync: uploadFile, isLoading: fileUploading } =
    useUploadOrganizationFile();

  const onFileUpload = useCallback(
    async (file: RcFile, source: FileSource) => {
      try {
        const fileResponse = await uploadFile({
          body: { file, source },
          contentType: OpenapiContentType.FormData,
        });
        if (fileResponse) {
          showNotification({
            type: 'success',
            message: 'Success',
            description: 'File uploaded successfully',
          });
        }
      } catch {
        showNotification({
          type: 'error',
          message: 'Error',
          description: 'Failed to upload file',
        });
      }
    },
    [showNotification, uploadFile],
  );

  return [fileUploading, onFileUpload] as const;
};
